import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Drawer, Switch } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TaxActions from '@Actions/taxActions';
import TaxForm from '../../../Vendors/CreateGst/TaxForm';
import './style.scss';

const Taxes = ({
  taxes, getTaxesLoading, user, getTaxes, isGroup, taxesGroup,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);
  const [showNewTaxModal, setShowNewTaxModal] = useState(false);
  const [showUpdateTaxModal, setShowUpdateGstModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedTax, setSelectedTax] = useState('');
  const [call, setCall] = useState(false);

  const gstListColumns = [
    {
      title: 'TAX NAME',
      key: 'name',
      render: (text, record) => `${record?.tax_name || '-'}`,
    },
    {
      title: 'TAX VALUE',
      render: (text, record) => (
        <Fragment>
          {`${record?.tax_value}%` || '-'}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setShowUpdateGstModal(true);
              setSelectedTax(record);
            }}
          >
            <EditOutlined />
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (user && !isUserReady) {
      getTaxes(user?.tenant_info?.org_id, currentPage, limit, null, isGroup);
      setIsUserReady(true);
    }
  }, []);

  useEffect(() => {
    if (call) {
      getTaxes(user?.tenant_info?.org_id, currentPage, limit, null, isGroup);
      setIsUserReady(true);
    }
  }, [call]);

  const getDataSource = () => {
    if (isGroup) {
      const data = taxesGroup || [];
      return data;
    }
    const data = taxes || [];
    return data;
  };

  return (
    <Fragment>
      <div className="taxes__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <div className="taxes__table__wrapper">
              <div className="taxes__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${getDataSource()?.count || '0'} ${isGroup ? 'Total Tax Group' : 'Total Taxes'}`}
                      {Helpers.getPermission(Helpers.permissionEntities.VENDORS,
                        Helpers.permissionTypes.CREATE, user) && (
                        <H3Button
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          text="+ New Tax"
                          onClick={() => setShowNewTaxModal(true)}
                          customClass="taxes__header__add-button hide__in-mobile"
                        />
                      )}
                    </div>
                  )}
                  loading={getTaxesLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={gstListColumns}
                  dataSource={getDataSource()?.data || []}
                  pagination={getDataSource()?.count > limit ? {
                    defaultCurrent: 1,
                    current: currentPage,
                    total: getDataSource() ? getDataSource()?.count : 0,
                    pageSize: limit,
                    onChange: (page) => {
                      setCurrentPage(page);
                      getTaxes(user?.tenant_info?.org_id, page, limit, null, isGroup);
                    },
                    position: ['bottomRight'],
                    showSizeChanger: false,
                  } : false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewTaxModal}
        width="360px"
        mask
        onClose={() => setShowNewTaxModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New Tax" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewTaxModal(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <TaxForm
            callback={() => {
              setShowNewTaxModal(false);
              setCall(!call);
            }}
            group={isGroup}
          />
        </div>
      </Drawer>
      <Drawer
        title="Update Tax"
        open={showUpdateTaxModal}
        onClose={() => setShowUpdateGstModal(false)}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update Tax" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateGstModal(false)} />
          </div>
        </div>
        <TaxForm
          selectedTax={selectedTax}
          callback={() => {
            setCall(!call);
            setShowUpdateGstModal(false);
          }}
          group={isGroup}
        />
      </Drawer>
    </Fragment>
  );
}; const mapStateToProps = ({
  UserReducers, TaxReducers,
}) => ({
  user: UserReducers.user,
  getTaxesLoading: TaxReducers.getTaxesLoading,
  taxes: TaxReducers.taxes,
  taxesGroup: TaxReducers.taxesGroup,
});

const mapDispatchToProps = (dispatch) => ({
  getTaxes: (orgId, page, limit, isActive, isTaxGroup) => dispatch(TaxActions.getTaxes(orgId, page, limit, isActive, isTaxGroup)),
});

Taxes.propTypes = {
  user: PropTypes.any,
  getTaxes: PropTypes.func,
  getTaxesLoading: PropTypes.bool,
  taxes: PropTypes.any,
  taxesGroup: PropTypes.any,
  isGroup: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Taxes));
